import { Campaign, Product, Place, Review, Category, User } from '../types';

// 더미 사용자 데이터
export const dummyUsers: User[] = [
  {
    uid: 'user1',
    email: 'reviewer1@example.com',
    displayName: '리뷰왕',
    photoURL: 'https://placehold.co/100',
    createdAt: new Date('2023-01-15'),
    updatedAt: new Date('2024-01-15'),
    points: 1250,
    level: 3,
    reviewCount: 45
  },
  {
    uid: 'user2',
    email: 'reviewer2@example.com',
    displayName: '맛집탐험가',
    photoURL: 'https://placehold.co/100',
    createdAt: new Date('2023-03-20'),
    updatedAt: new Date('2024-01-10'),
    points: 890,
    level: 2,
    reviewCount: 28
  }
];

// 더미 카테고리 데이터
export const dummyCategories: Category[] = [
  {
    id: 'beauty',
    name: '뷰티',
    description: '화장품, 스킨케어',
    color: '#FF6B9D',
    icon: '💄',
    type: 'product'
  },
  {
    id: 'food',
    name: '음식',
    description: '식품, 음료',
    color: '#4ECDC4',
    icon: '🍕',
    type: 'product'
  },
  {
    id: 'restaurant',
    name: '맛집',
    description: '식당, 카페',
    color: '#45B7D1',
    icon: '🍽️',
    type: 'place'
  },
  {
    id: 'electronics',
    name: '전자제품',
    description: '스마트폰, 가전제품',
    color: '#96CEB4',
    icon: '📱',
    type: 'product'
  },
  {
    id: 'fashion',
    name: '패션',
    description: '의류, 액세서리',
    color: '#FECA57',
    icon: '👗',
    type: 'product'
  },
  {
    id: 'travel',
    name: '여행',
    description: '호텔, 관광지',
    color: '#FF9FF3',
    icon: '✈️',
    type: 'place'
  }
];

// 더미 캠페인 데이터
export const dummyCampaigns: Campaign[] = [
  {
    id: 'campaign1',
    title: '신상 립스틱 체험단 모집',
    description: '새로 출시된 매트 립스틱을 체험하고 솔직한 리뷰를 남겨주세요!',
    imageUrl: 'https://placehold.co/400x300?text=립스틱',
    brand: '뷰티브랜드',
    category: 'product',
    type: 'popular',
    reward: {
      points: 500,
      type: 'points',
      description: '포인트 적립'
    },
    deadline: new Date('2024-02-28'),
    participantCount: 45,
    maxParticipants: 50,
    status: 'active',
    requirements: ['20세 이상', '뷰티 관심자', '인스타그램 계정 보유'],
    tags: ['뷰티', '립스틱', '무료체험'],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-15')
  },
  {
    id: 'campaign2',
    title: '강남 신상 카페 방문 후기',
    description: '강남역 근처 새로 오픈한 카페를 방문하고 후기를 작성해주세요.',
    imageUrl: 'https://placehold.co/400x300?text=카페',
    brand: '카페브랜드',
    category: 'place',
    type: 'new',
    reward: {
      points: 300,
      type: 'points',
      description: '포인트 적립'
    },
    deadline: new Date('2024-02-15'),
    participantCount: 12,
    maxParticipants: 20,
    status: 'active',
    requirements: ['서울 거주자', '카페 방문 가능'],
    tags: ['카페', '강남', '신상'],
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-01-12')
  },
  {
    id: 'campaign3',
    title: '스마트폰 케이스 체험단',
    description: '최신 스마트폰 케이스를 체험하고 리뷰를 작성해주세요.',
    imageUrl: 'https://placehold.co/400x300?text=폰케이스',
    brand: '테크브랜드',
    category: 'product',
    type: 'ongoing',
    reward: {
      points: 400,
      type: 'points',
      description: '포인트 적립'
    },
    deadline: new Date('2024-03-10'),
    participantCount: 8,
    maxParticipants: 15,
    status: 'active',
    requirements: ['스마트폰 보유', '리뷰 작성 경험'],
    tags: ['전자제품', '스마트폰', '케이스'],
    createdAt: new Date('2024-01-05'),
    updatedAt: new Date('2024-01-08')
  },
  {
    id: 'campaign4',
    title: '홈카페 원두 체험',
    description: '프리미엄 원두를 체험하고 맛에 대한 솔직한 후기를 남겨주세요.',
    imageUrl: 'https://placehold.co/400x300?text=원두',
    brand: '커피브랜드',
    category: 'product',
    type: 'popular',
    reward: {
      points: 600,
      type: 'points',
      description: '포인트 적립'
    },
    deadline: new Date('2024-02-25'),
    participantCount: 32,
    maxParticipants: 40,
    status: 'active',
    requirements: ['커피 애호가', '홈카페 경험'],
    tags: ['커피', '원두', '홈카페'],
    createdAt: new Date('2024-01-02'),
    updatedAt: new Date('2024-01-14')
  },
  {
    id: 'campaign5',
    title: '신상 패션 아이템 체험',
    description: '봄 시즌 신상 의류를 체험하고 스타일링 후기를 작성해주세요.',
    imageUrl: 'https://placehold.co/400x300?text=패션',
    brand: '패션브랜드',
    category: 'product',
    type: 'new',
    reward: {
      points: 800,
      type: 'points',
      description: '포인트 적립'
    },
    deadline: new Date('2024-03-15'),
    participantCount: 5,
    maxParticipants: 25,
    status: 'active',
    requirements: ['패션 관심자', '스타일링 가능'],
    tags: ['패션', '의류', '스타일링'],
    createdAt: new Date('2024-01-12'),
    updatedAt: new Date('2024-01-13')
  },
  {
    id: 'campaign6',
    title: '제주도 펜션 체험',
    description: '제주도 신규 펜션을 체험하고 여행 후기를 작성해주세요.',
    imageUrl: 'https://placehold.co/400x300?text=펜션',
    brand: '여행브랜드',
    category: 'place',
    type: 'ongoing',
    reward: {
      points: 1000,
      type: 'points',
      description: '포인트 적립'
    },
    deadline: new Date('2024-04-30'),
    participantCount: 3,
    maxParticipants: 10,
    status: 'active',
    requirements: ['제주도 여행 가능', '숙박 체험'],
    tags: ['여행', '제주도', '펜션'],
    createdAt: new Date('2024-01-08'),
    updatedAt: new Date('2024-01-11')
  }
];

// 더미 상품 데이터
export const dummyProducts: Product[] = [
  {
    id: 'product1',
    name: '매트 립스틱',
    description: '오래 지속되는 매트 립스틱',
    imageUrl: 'https://placehold.co/300x300?text=립스틱',
    brand: '뷰티브랜드',
    category: 'beauty',
    price: 25000,
    averageRating: 4.5,
    reviewCount: 128,
    tags: ['뷰티', '립스틱', '매트']
  },
  {
    id: 'product2',
    name: '스마트폰 케이스',
    description: '충격 보호 스마트폰 케이스',
    imageUrl: 'https://placehold.co/300x300?text=폰케이스',
    brand: '테크브랜드',
    category: 'electronics',
    price: 15000,
    averageRating: 4.2,
    reviewCount: 89,
    tags: ['전자제품', '케이스', '보호']
  }
];

// 더미 장소 데이터
export const dummyPlaces: Place[] = [
  {
    id: 'place1',
    name: '강남 신상 카페',
    description: '분위기 좋은 강남 카페',
    imageUrl: 'https://placehold.co/300x300?text=카페',
    address: '서울시 강남구 강남대로 123',
    category: 'restaurant',
    averageRating: 4.3,
    reviewCount: 45,
    tags: ['카페', '강남', '분위기'],
    location: {
      lat: 37.5665,
      lng: 126.9780
    }
  },
  {
    id: 'place2',
    name: '제주도 펜션',
    description: '바다 전망 제주도 펜션',
    imageUrl: 'https://placehold.co/300x300?text=펜션',
    address: '제주시 제주도로 456',
    category: 'travel',
    averageRating: 4.7,
    reviewCount: 23,
    tags: ['펜션', '제주도', '바다전망'],
    location: {
      lat: 33.4996,
      lng: 126.5312
    }
  }
];

// 더미 리뷰 데이터
export const dummyReviews: Review[] = [
  {
    id: 'review1',
    campaignId: 'campaign1',
    userId: 'user1',
    rating: 5,
    title: '정말 좋은 립스틱!',
    content: '발색도 좋고 지속력도 뛰어나네요. 추천합니다!',
    images: ['https://placehold.co/200x200?text=리뷰1'],
    pros: ['발색 좋음', '지속력 뛰어남', '가격 합리적'],
    cons: ['용량이 작음'],
    tags: ['뷰티', '립스틱', '추천'],
    likeCount: 12,
    commentCount: 3,
    createdAt: new Date('2024-01-16'),
    updatedAt: new Date('2024-01-16'),
    isVerified: true,
    status: 'approved',
    rewardEarned: 500
  },
  {
    id: 'review2',
    campaignId: 'campaign2',
    userId: 'user2',
    rating: 4,
    title: '분위기 좋은 카페',
    content: '커피 맛도 좋고 인테리어도 예뻐요. 다시 방문하고 싶습니다.',
    images: ['https://placehold.co/200x200?text=리뷰2'],
    pros: ['분위기 좋음', '커피 맛있음', '인테리어 예쁨'],
    cons: ['가격이 조금 비쌈', '주차 불편'],
    tags: ['카페', '분위기', '인테리어'],
    likeCount: 8,
    commentCount: 2,
    createdAt: new Date('2024-01-17'),
    updatedAt: new Date('2024-01-17'),
    isVerified: true,
    status: 'approved',
    rewardEarned: 300
  }
];

// 헬퍼 함수들
export const getPopularCampaigns = (): Campaign[] => {
  return dummyCampaigns.filter(campaign => campaign.type === 'popular');
};

export const getNewCampaigns = (): Campaign[] => {
  return dummyCampaigns.filter(campaign => campaign.type === 'new');
};

export const getOngoingCampaigns = (): Campaign[] => {
  return dummyCampaigns.filter(campaign => campaign.type === 'ongoing');
};

export const getCampaignsByCategory = (categoryId: string): Campaign[] => {
  return dummyCampaigns.filter(campaign => {
    const category = dummyCategories.find(cat => cat.id === categoryId);
    return category && campaign.category === category.type;
  });
};

export const getActiveCampaigns = (): Campaign[] => {
  return dummyCampaigns.filter(campaign => campaign.status === 'active');
};

export const getReviewsByCampaign = (campaignId: string): Review[] => {
  return dummyReviews.filter(review => review.campaignId === campaignId);
};

export const getUserReviews = (userId: string): Review[] => {
  return dummyReviews.filter(review => review.userId === userId);
}; 